"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSortBy = void 0;

var react_1 = __importDefault(require("react"));

var hooks_1 = require("../hooks");

var utility_1 = require("../utility");

var useSortBy = function useSortBy() {
  var _ref = (0, hooks_1.useReactifySearchContext)(),
      options = _ref.options,
      config = _ref.config,
      sortby = _ref.sortby;

  var _ref2 = (0, hooks_1.useAnalytics)(),
      track = _ref2.track;

  var sortOptions = react_1.default.useMemo(function () {
    return config.sort.sort(function (a, b) {
      var aInt = typeof a.position === "string" ? parseInt(a.position, 10) : a.position;
      var bInt = typeof b.position === "string" ? parseInt(b.position, 10) : b.position;
      return aInt - bInt;
    }).filter(function (_ref3) {
      var visibility = _ref3.visibility;
      return ["all", options.mode].includes(visibility);
    });
  }, [options.mode, config]);
  var sortOption = react_1.default.useMemo(function () {
    return sortOptions.find(function (_ref4) {
      var handle = _ref4.handle;
      return handle === sortby.sortOption;
    }) || sortOptions[0];
  }, [sortOptions, sortby.sortOption]);
  var setSortOption = react_1.default.useCallback(function (sortOptionHandle) {
    var ignoreHistoryState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (typeof window === "undefined") {
      return;
    }

    utility_1.debug.log("useSortBy", "setSortOption[sortOptionHandle]", sortOptionHandle);
    sortby.setSortOption(sortOptionHandle);

    if (!ignoreHistoryState) {
      var url = new URL(window.location.href);

      if (url.searchParams.has("sort")) {
        url.searchParams.set("sort", sortOptionHandle);
      } else {
        url.searchParams.append("sort", sortOptionHandle);
      }

      window.history.pushState({}, "", url.toString());
    }

    track({
      eventName: "sortChange",
      payload: {
        type: sortOptionHandle
      }
    });
  }, [typeof window === "undefined" ? "" : window.location.href]);
  utility_1.debug.hook("useSortBy", "sortOption", sortOption);
  utility_1.debug.hook("useSortBy", "sortOptions", sortOptions);
  return {
    sortOptions: sortOptions,
    sortOption: sortOption,
    setSortOption: setSortOption
  };
};

exports.useSortBy = useSortBy;